<template>
	<div class="mark-as-seen-modal-container mark-as-seen-modal--collapsed">
		<div class="jw-content">
			<MarkAsSeen
				:titleId="titleId"
				:titleObjectType="titleObjectType"
				:titleObjectId="titleObjectId"
				:titleName="titleName"
				:titleContentType="titleContentType"
				:seenEpisodeCount="seenEpisodeCount"
				:posterUrl="posterUrl"
				:backdrops="backdrops"
				:additionalContexts="additionalContexts"
				@done="$emit('close-modal')"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { SnowplowContext } from '@/helpers/tracking/providers';

import MarkAsSeen from '@/components/mark-as-seen/MarkAsSeen.vue';
import { Backdrop, ObjectType } from '@/@types/graphql-types';
import { TitleContentType } from '@/interfaces/snowplow/title-context';

withDefaults(
	defineProps<{
		titleId: string;
		titleObjectType: ObjectType;
		titleObjectId: number;
		titleContentType?: TitleContentType;
		titleName?: string;
		seenEpisodeCount?: number;
		posterUrl?: string;
		backdrops?: Pick<Backdrop, 'backdropUrl'>[];
		additionalContexts?: SnowplowContext[];
	}>(),
	{
		titleName: '',
		posterUrl: '',
		backdrops: () => [],
		additionalContexts: () => [],
	}
);

defineEmits<{
	(e: 'close-modal'): void;
}>();
</script>

<style lang="scss">
@import '~@/styles/variables';

.mark-as-seen-modal {
	height: 100%;

	.modal-wrapper {
		z-index: 40;
		transition: top 0.5s;
		border-radius: 20px;

		.mark-as-seen-modal-container {
			border-radius: 20px;
			height: 100%;
		}
	}
}
</style>
